import { useEffect, useRef } from "react";
import { Info } from "lucide-react";

/**
 * The right-click menu on a menu item or cart line (billing PC, mouse). One
 * entry today — "Show details" — positioned at the pointer and kept on screen.
 * Closes on any click elsewhere, Escape, scroll or resize.
 */
export default function ItemContextMenu({ at, onShowDetails, onClose }) {
  const menu = useRef(null);

  useEffect(() => {
    menu.current?.querySelector("button")?.focus?.();
    const away = event => {
      if (!menu.current?.contains(event.target)) onClose();
    };
    const key = event => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("mousedown", away);
    document.addEventListener("keydown", key);
    window.addEventListener("scroll", onClose, true);
    window.addEventListener("resize", onClose);
    return () => {
      document.removeEventListener("mousedown", away);
      document.removeEventListener("keydown", key);
      window.removeEventListener("scroll", onClose, true);
      window.removeEventListener("resize", onClose);
    };
  }, [onClose]);

  const width = 200;
  const height = 48;
  const left = Math.max(8, Math.min(at.x, (window.innerWidth || width) - width - 8));
  const top = Math.max(8, Math.min(at.y, (window.innerHeight || height) - height - 8));

  return (
    <div
      ref={menu}
      role="menu"
      className="fixed z-[130] bg-card border rounded-md shadow-lg py-1"
      style={{ left, top, width }}
      data-testid="item-context-menu"
    >
      <button
        type="button"
        role="menuitem"
        className="w-full flex items-center gap-2 px-3 h-10 text-body text-left hover:bg-muted focus:bg-muted outline-none"
        onClick={() => {
          onShowDetails();
          onClose();
        }}
        data-testid="item-context-show-details"
      >
        <Info className="w-4 h-4 text-muted-foreground" /> Show details
      </button>
    </div>
  );
}
